import React, { useEffect } from "react";
import {
  Box,
  TextField,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import ColorThemeSelector from "./ColorThemeSelector";
import CharacterListSelector from "./CharacterListSelector";
import BeerBrandSelector from "./BeerBrandSelector";

const CakeCustomizationForm = ({
  fields,
  values,
  setValues,
  onResetCustomizations,
}) => {
  useEffect(() => {
    if (!values.characters || values.characters.length === 0) {
      setValues((prev) => ({
        ...prev,
        characters: [{ type: "", char: "" }],
      }));
    }
  }, [setValues, values.characters]);

  const handleChange = (key) => (e) => {
    setValues((prev) => ({ ...prev, [key]: e.target.value }));
  };

  return (
    <Box sx={{ mt: 3, display: "flex", flexDirection: "column", gap: 2 }}>
      <ColorThemeSelector
        colorFields={fields.filter((f) => f.type === "colorpicker")}
        values={values}
        setValues={setValues}
        onResetCustomizations={onResetCustomizations}
      />

      {/* All other fields */}
      {fields
        .filter((field) => field.type !== "colorpicker")
        .map((field) => {
          const { key, label, type, required, options, warning, visibleIf } =
            field;

          // Conditional visibility
          if (visibleIf) {
            const shouldShow = Object.entries(visibleIf).every(
              ([depKey, depVal]) => values[depKey] === depVal
            );
            if (!shouldShow) return null;
          }

          return (
            <Box key={key}>
              {type === "characterList" && (
                <CharacterListSelector
                  key={key}
                  field={field}
                  value={values[key] || []}
                  onChange={(newList) =>
                    setValues((prev) => ({ ...prev, [key]: newList }))
                  }
                />
              )}

              {type === "beerBrand" && (
                <BeerBrandSelector
                  value={values[key] || ""}
                  onChange={(newVal) =>
                    setValues((prev) => ({ ...prev, [key]: newVal }))
                  }
                />
              )}
            </Box>
          );
        })}
    </Box>
  );
};

export default CakeCustomizationForm;
